<template>
  <!-- Old bit.dev component -->
  <div class="c-base-summary">
    <div v-if="isHeader" class="c-base-summary__header">
      <!-- Slot to set content header -->
      <slot name="header"></slot>
    </div>
    <!-- Slot to set content body -->
    <slot></slot>
    <div v-if="isFooter" class="c-base-summary__footer">
      <!-- Slot to set content footer -->
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Define visibility of slot footer
    isHeader: {
      type: Boolean,
      default: true,
    },
    isFooter: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
.c-base-summary {
  max-width: 480px;
  margin: 0 auto;
  padding: 18px;
  border: 1px solid $gray-3;

  &__header,
  &__footer {
    max-width: 70%;
    padding-bottom: 6px;
    margin: 6px auto;
    text-align: center;
    border-bottom: 1px solid $gray-3;
  }

  &__footer {
    padding-top: 6px;
    padding-bottom: 0;
    margin-top: 6px;
    margin-bottom: 0;
    border-top: 1px solid $gray-3;
    border-bottom: 0;
  }
}
</style>
